import React from "react";
import "pages/pickers/Pickers.scss";
import { TabControler } from "component/TabControler/TabControler";
import FilterPickers from "pages/pickers/filter/FilterContainer";
import { TablePickers } from "./TablePickers/TablePIckers";
import { PickerTypes } from "./types";
import { pickerTabs } from "./types";
import { TabType } from "component/TabControler/types";
import { ReactComponent as Clock } from "assets/relojOscuro.svg";
import { ReactComponent as Worker } from "assets/trabajadorOscuro.svg";
import { useTranslation } from "react-i18next";
import "./i18n";
import { ACTIVE_PICKER_STATUS } from "utils/constants";

const tabs: TabType<pickerTabs>[] = [
  {
    title: "pickers:pending",
    id: "pending",
    icon: Clock,
    testId: "pickers-tab-pending",
    name: "pending",
  },
  {
    title: "pickers:pickers",
    id: "pickers",
    icon: Worker,
    testId: "pickers-tab-active",
    name: "pickers",
  },
];

export const Pickers: React.FC<PickerTypes> = ({
  actualPage,
  pendingUsers,
  filters,
  filtersExtraSeeMore,
  seeMore,
  getMorePendingUser,
  getPendingUsersExportRequest,
  testId,
  collapseTable,
  changePage,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div>
      <TabControler<pickerTabs>
        tabs={tabs}
        changePage={changePage}
        actualPage={actualPage}
        clickable={false}
      />

      <div className="picker-title-container">
        <h2 className="subTitle-pending">
          <p
            className="subtitle-pendingUser-h2"
            data-testId={`${testId}-title`}
          >
            {actualPage === "pending"
              ? t("pickers:pending")
              : t("pickers:pickers")}
          </p>
        </h2>
      </div>
      <FilterPickers testId={`${testId}-filters`} actualPage={actualPage} />
      <br />
      <TablePickers
        actualPage={actualPage}
        pendingUsers={pendingUsers}
        testId={`${testId}-table`}
        seeMore={seeMore}
        collapseTable={collapseTable}
        getMorePickers={() =>
          getMorePendingUser({
            ...filters,
            ...filtersExtraSeeMore,
            identificationType: filters.identificationType?.tag,
            vehicleType: filters.vehicleType || undefined,
            status: filters.status || ACTIVE_PICKER_STATUS.join(","),
          })
        }
      />
    </div>
  );
};
